import React from 'react';
import { motion, useReducedMotion } from 'framer-motion';
import { EASE_OUT, STAGGER_STEP, CARD_DURATION } from '../utils/animations';

// Wraps a dashboard card/section so it fades in + slides up ~16px (and
// scales from 0.98 -> 1) on mount, staggered by `order` (or an explicit
// `delay`) so cards reveal top-left to bottom-right instead of all at once.
//
// Renders a plain element with no animation when the user has
// prefers-reduced-motion enabled — it jumps straight to the final state.
const RevealCard = React.memo(({
    order = 0,
    delay,
    stagger = STAGGER_STEP,
    duration = CARD_DURATION,
    as = 'div',
    style,
    className,
    children,
    ...rest
}) => {
    const reduceMotion = useReducedMotion();
    const resolvedDelay = typeof delay === 'number' ? delay : order * stagger;

    if (reduceMotion) {
        const Tag = as;
        return (
            <Tag style={style} className={className} {...rest}>
                {children}
            </Tag>
        );
    }

    const MotionTag = motion[as] || motion.div;

    return (
        <MotionTag
            style={style}
            className={className}
            initial={{ opacity: 0, y: 16, scale: 0.98 }}
            animate={{ opacity: 1, y: 0, scale: 1 }}
            transition={{ duration, ease: EASE_OUT, delay: resolvedDelay }}
            {...rest}
        >
            {children}
        </MotionTag>
    );
});

RevealCard.displayName = 'RevealCard';

export default RevealCard;
